/*
 * API Solides
 * \"API de integração com o sistema Solides Gestão. A mesma oferece criação, edição, atualização de registros importantes para sua empresa como: Passaportes, Colaboradores, Ocorrências, Currículos e Vagas.  É obrigatório informar na URL base o parâmetro {locale} cujo os valores possvíeis são: <b>pt-BR</b>, ou <b>es</b>, ou <b>en</b>\"  Para gerar o token de acesso siga os seguintes passos: 1. Acesse https://system.solides.com/pt-BR/usuarios/sign_in e logue com seu usuário. 2. Acesse o sub-menu <b>Configurações</b> 3. Na seção <b>Ativar API de Integração</b>, clique em <b>Ativar API</b>. Isso gerará um token único que deverá ser utilizado em todas as requisições. 4. Configure a Header de sua requisição com essas duas variáveis:     - Content-Type: application/json     - authorization: Token token=<b>[SEU TOKEN]</b> 
 *
 * OpenAPI spec version: 1.0.14
 * Contact: suporte@solides.com.br
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.13
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MotivoDeDemissao'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MotivoDeDemissao'));
  } else {
    // Browser globals (root is window)
    if (!root.ApiSolides) {
      root.ApiSolides = {};
    }
    root.ApiSolides.MotivoDeDemissesApi = factory(root.ApiSolides.ApiClient, root.ApiSolides.MotivoDeDemissao);
  }
}(this, function(ApiClient, MotivoDeDemissao) {
  'use strict';

  /**
   * MotivoDeDemisses service.
   * @module api/MotivoDeDemissesApi
   * @version 1.0.14
   */

  /**
   * Constructs a new MotivoDeDemissesApi. 
   * @alias module:api/MotivoDeDemissesApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the searchMotivoDemissao operation.
     * @callback module:api/MotivoDeDemissesApi~searchMotivoDemissaoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MotivoDeDemissao} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Busca por um motivo de demissão
     * @param {Number} id identificador único do motivo
     * @param {module:api/MotivoDeDemissesApi~searchMotivoDemissaoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MotivoDeDemissao}
     */
    this.searchMotivoDemissao = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling searchMotivoDemissao");
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MotivoDeDemissao;

      return this.apiClient.callApi(
        '/motivo_demissoes/{id}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the searchMotivoDemissoes operation.
     * @callback module:api/MotivoDeDemissesApi~searchMotivoDemissoesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MotivoDeDemissao>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Busca por todos motivos de demissão
     * @param {module:api/MotivoDeDemissesApi~searchMotivoDemissoesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MotivoDeDemissao>}
     */
    this.searchMotivoDemissoes = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [MotivoDeDemissao];

      return this.apiClient.callApi(
        '/motivo_demissoes', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
